import JoinRoomButton from './JoinRoomButton.js';
import CreateRoomButton from './CreateRoomButton.js' 
import { Stack, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText, Box, Button} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {useState} from 'react';


export default function MultiplayerRoomSetup({socket}) {
    const [open, setOpen] = useState(false);

    return (
    <>  

    <Button className='btn' color='inherit' variant="outlined" onClick={() => setOpen(true)} endIcon={<AddCircleOutlineIcon/>}>
        Multiplayer
    </Button>

        <Dialog
            fullWidth
            maxWidth='sm'
            open={open}
            onClose={() => setOpen(false)}
          >
            <DialogTitle> Multiplayer </DialogTitle>
            <DialogContent>
            
              <DialogContentText>
                Create a room or join an existing room by room id!
              </DialogContentText>
              <Box sx={{ mt: 4, mb:-1 }}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems='center'>
                    <CreateRoomButton socket={socket}/>
                    <JoinRoomButton socket={socket}/>
                </Stack>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen(false)}> Close </Button>
            </DialogActions>
          </Dialog>

    </>
    )
}